// typescript
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { protectedResources } from '../services/msal-config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private cachedToken: string | null = null;
  private tokenExpiryTime: number = 0;

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if we have a valid cached token (with 5 minute buffer)
    const now = Date.now();
    if (this.cachedToken && this.tokenExpiryTime > now + 5 * 60 * 1000) {
      // Use cached token
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.cachedToken}`
        }
      });
      return next.handle(authReq);
    }

    // Acquire fresh token with API scope so the token contains roles and is accepted by the API
    return from(this.authService.getAccessToken(protectedResources.functionApi.scopes)).pipe(
      switchMap((token) => {
        if (token) {
          // Cache the token (tokens typically expire in 1 hour)
          this.cachedToken = token;
          this.tokenExpiryTime = now + 55 * 60 * 1000; // Cache for 55 minutes

          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(authReq);
        }
        return next.handle(req);
      })
    );
  }
}